@if (visible()) {
  <div class="news-overview" [class.desktop]="isDesktop()">
    <app-v3-overview-card-header
      icon="/v3/news.svg"
      title="News"
      [updatedAt]="updatedAt()"
      actionLabel="Alle News"
      [zeroDesktopClickable]="false"
      (navigate)="onNavigate()"
    ></app-v3-overview-card-header>

    <div
      class="quote"
      role="button"
      tabindex="0"
      (click)="onNavigate()"
      (keyup.enter)="onNavigate()"
      (keydown.space)="$event.preventDefault(); onNavigate()"
    >
      <span class="notch"></span>
      <p class="quote-title">{{ title() }}</p>
    </div>
    <p class="description">{{ description() }}</p>

    @if (isFinnet() && !isFinnetDesktop()) {
      <button class="news-details" type="button" (click)="onNavigate()">
        <span>Newsübersicht</span>
        <span class="caret"></span>
      </button>
    }
  </div>
}
